// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionThree-Solutions {
  background: linear-gradient(to bottom, #e0e4fb 0%, #e0e4fb 50%, #1C2640 50%, #1C2640 100%);
  height: auto !important;
  width: 100%;
  padding-top: 20vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -35vh;
  padding-top: 20vh;
}
.sectionThree-Solutions #SolutionsSectionThree-content {
  width: 80%;
  margin-top: 7%;
}
.sectionThree-Solutions #SolutionsSectionThree-head {
  font-style: normal;
  font-weight: 500;
  font-size: 35px;
  line-height: 50px;
  margin-top: -100px;
  margin-bottom: 10px;
  color: #EC6927 !important;
  text-align: center;
  font-weight: 500;
}
.sectionThree-Solutions #SolutionsSectionThree-subhead {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 15px !important;
  margin-top: 1%;
  text-align: center;
  color: #1c2640 !important;
}
.sectionThree-Solutions #SolutionsSectionThree-card-section {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  grid-gap: 10%;
  gap: 10%;
  margin-top: 5%;
  padding-left: 25px;
}
.sectionThree-Solutions #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-1 {
  margin-right: -50px;
}
.sectionThree-Solutions #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-2 {
  margin-left: -50px;
}
.sectionThree-Solutions #SolutionsSectionThree-card1,
.sectionThree-Solutions #SolutionsSectionThree-card2,
.sectionThree-Solutions #SolutionsSectionThree-card3 {
  width: 362px;
  height: 286px !important;
  background: #FFFFFF;
  box-shadow: 5px 5px 5px rgba(51, 51, 51, 0.25);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sectionThree-Solutions #SolutionsSectionThree-card1-top,
.sectionThree-Solutions #SolutionsSectionThree-card2-top,
.sectionThree-Solutions #SolutionsSectionThree-card3-top {
  display: flex;
  width: 90%;
  flex-direction: row;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  margin-top: 7%;
  grid-gap: 5%;
  gap: 5%;
  line-height: 1.6;
  font-size: 16px;
  color: #EC6927;
  font-weight: 600;
  padding-left: 30px;
}
.sectionThree-Solutions #SolutionsSectionThree-card1-head,
.sectionThree-Solutions #SolutionsSectionThree-card2-head,
.sectionThree-Solutions #SolutionsSectionThree-card3-head {
  display: flex;
  flex-direction: column;
  width: 70%;
}
.sectionThree-Solutions #SolutionsSectionThree-card1-head1,
.sectionThree-Solutions #SolutionsSectionThree-card2-head1,
.sectionThree-Solutions #SolutionsSectionThree-card3-head1 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #1C2640;
}
.sectionThree-Solutions #SolutionsSectionThree-card1-head2,
.sectionThree-Solutions #SolutionsSectionThree-card2-head2,
.sectionThree-Solutions #SolutionsSectionThree-card3-head2 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 20px;
  color: #1C2640;
  margin-top: 3%;
}
.sectionThree-Solutions #SolutionsSectionThree-card1-top img,
.sectionThree-Solutions #SolutionsSectionThree-card2-top img {
  display: flex;
  flex-direction: column;
  width: 70px !important;
  height: 70px !important;
}
.sectionThree-Solutions #SolutionsSectionThree-card3-top img {
  display: flex;
  flex-direction: column;
  width: 70px !important;
  height: 50px !important;
}
.sectionThree-Solutions #SolutionsSectionThree-card1-head,
.sectionThree-Solutions #SolutionsSectionThree-card2-head,
.sectionThree-Solutions #SolutionsSectionThree-card3-head {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.sectionThree-Solutions #SolutionsSectionThree-card1-para {
  width: 90%;
  height: 162px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  color: #1C2640;
  padding: 10px 30px;
}
.sectionThree-Solutions #SolutionsSectionThree-card2-para {
  width: 90%;
  height: 153px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  color: #1C2640;
  margin-top: 7%;
  padding: 10px 30px;
}
.sectionThree-Solutions #SolutionsSectionThree-card3-para {
  width: 90%;
  height: 153px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  color: #1C2640;
  margin-top: 7%;
  padding: 10px 30px;
}
.sectionThree-Solutions #SolutionsSectionThree-discoverAll {
  color: #EC6927;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  width: 90%;
  margin-top: 5%;
  cursor: pointer;
}
.sectionThree-Solutions div#SolutionsSectionThree-left-middle-bottom {
  padding: 30px;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: -10px;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  padding-bottom: 45px;
}
.sectionThree-Solutions #SolutionsSectionThree-explore-platform-btn {
  background: #EC6927;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  color: white;
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  cursor: pointer;
  padding: 10px 20px;
}
.sectionThree-Solutions #SolutionsSectionThree-bottom {
  flex-direction: row;
  justify-content: flex-start;
  background: #fff;
  width: 100%;
  padding: 75px 130px;
  scroll-snap-align: end;
}
.sectionThree-Solutions .SolutionsSectionThree-footer-head {
  font-size: 35px;
  color: #1c2640;
}
.sectionThree-Solutions .SolutionsSectionThree-footer-content {
  margin-top: 3%;
  display: flex;
}
.sectionThree-Solutions .SolutionsSectionThree-btn-footer {
  margin-left: 20%;
}
.sectionThree-Solutions .SolutionsSectionThree-footer-disc {
  width: 34%;
}
.sectionThree-Solutions button#SolutionsSectionThree-schedule-btn {
  background: #ec6927;
  border-radius: 50px;
  padding: 10px 20px;
  margin-right: 20px;
  color: #fff;
  border: 1px solid #ec6927;
}
.sectionThree-Solutions button#SolutionsSectionThree-watch-btn {
  background: #1c2640;
  border-radius: 50px;
  padding: 10px 20px;
  margin-right: 20px;
  color: #fff;
  border: 1px solid #1c2640;
}
.sectionThree-Solutions img#SolutionsSectionThree-dots-bg {
  margin-top: -3%;
  float: right;
  width: 200px;
  margin-right: -140px;
  margin-bottom: -200px;
  height: 90px;
}`, "",{"version":3,"sources":["webpack://./src/components/Solutions/SectionThree/sectionThree.scss"],"names":[],"mappings":"AAAA;EACI,0FAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AACJ;AACI;EACI,UAAA;EACA,cAAA;AACR;AACI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACR;AACI;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AACR;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;AACR;AAAQ;EACI,mBAAA;AAEZ;AAAQ;EACI,kBAAA;AAEZ;AACI;;;EAGI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACR;AACI;;;EAGI,aAAA;EACA,UAAA;EACA,mBAAA;EACA,kCAAA;EACA,sCAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACR;AACI;;;EAGI,aAAA;EACA,sBAAA;EACA,UAAA;AACR;AACI;;;EAGI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACR;AAEI;;;EAGI,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAAR;AAII;;EAEI,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAFR;AAKK;EACG,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAHR;AAMI;;;EAGI,aAAA;EACA,sBAAA;EACA,WAAA;AAJR;AAMI;EACI,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAJR;AAMI;EACI,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAJR;AAMI;EACI,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAJR;AAMI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAJR;AAOI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AALR;AAQI;EACI,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AANR;AASI;EACI,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;AAPR;AAWI;EACI,eAAA;EACA,cAAA;AATR;AAcI;EACI,cAAA;EACA,aAAA;AAZR;AAeI;EACI,gBAAA;AAbR;AAgBI;EACI,UAAA;AAdR;AAiBI;EACI,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAfR;AAkBI;EACI,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAhBR;AAmBI;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,YAAA;AAjBR","sourcesContent":[".sectionThree-Solutions {\n    background: linear-gradient( to bottom, #e0e4fb 0%, #e0e4fb 50%, #1C2640 50%, #1C2640 100% );\n    height: auto !important;\n    width: 100%;\n    padding-top: 20vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: -35vh;\n    padding-top: 20vh;\n\n    #SolutionsSectionThree-content {\n        width: 80%;\n        margin-top: 7%;\n    }\n    #SolutionsSectionThree-head {\n        font-style: normal;\n        font-weight: 500;\n        font-size: 35px;\n        line-height: 50px;\n        margin-top: -100px;\n        margin-bottom: 10px;\n        color: #EC6927 !important;\n        text-align: center;\n        font-weight: 500;\n    }\n    #SolutionsSectionThree-subhead {\n        font-style: normal;\n        font-weight: normal;\n        font-size: 16px;\n        line-height: 15px !important;\n        margin-top: 1%;\n        text-align: center;\n        color: #1c2640 !important;\n    }\n    #SolutionsSectionThree-card-section {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        grid-gap: 10%;\n        gap: 10%;\n        margin-top: 5%;\n        padding-left: 25px;\n        #SolutionsSectionThree-delivery-approach-image-1 {\n            margin-right: -50px;\n        }\n        #SolutionsSectionThree-delivery-approach-image-2 {\n            margin-left: -50px;\n        }\n    }\n    #SolutionsSectionThree-card1,\n    #SolutionsSectionThree-card2,\n    #SolutionsSectionThree-card3 {\n        width: 362px;\n        height: 286px !important;\n        background: #FFFFFF;\n        box-shadow: 5px 5px 5px rgba(51, 51, 51, 0.25);\n        border-radius: 12px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    #SolutionsSectionThree-card1-top,\n    #SolutionsSectionThree-card2-top,\n    #SolutionsSectionThree-card3-top {\n        display: flex;\n        width: 90%;\n        flex-direction: row;\n        align-items: flex-start !important;\n        justify-content: flex-start !important;\n        margin-top: 7%;\n        grid-gap: 5%;\n        gap: 5%;\n        line-height: 1.6;\n        font-size: 16px;\n        color: #EC6927;\n        font-weight: 600;\n        padding-left: 30px;\n    }\n    #SolutionsSectionThree-card1-head,\n    #SolutionsSectionThree-card2-head,\n    #SolutionsSectionThree-card3-head{\n        display: flex;\n        flex-direction: column;\n        width: 70%;\n    }\n    #SolutionsSectionThree-card1-head1,\n    #SolutionsSectionThree-card2-head1,\n    #SolutionsSectionThree-card3-head1 {\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 20px;\n        color: #1C2640;\n    }\n\n    #SolutionsSectionThree-card1-head2,\n    #SolutionsSectionThree-card2-head2,\n    #SolutionsSectionThree-card3-head2 {\n        font-style: normal;\n        font-weight: bold;\n        font-size: 24px;\n        line-height: 20px;\n        color: #1C2640;\n        margin-top: 3%;\n    }\n\n\n    #SolutionsSectionThree-card1-top img,\n    #SolutionsSectionThree-card2-top img{\n        display: flex;\n        flex-direction: column;\n        width: 70px !important;\n        height: 70px !important;\n    }\n\n     #SolutionsSectionThree-card3-top img{\n        display: flex;\n        flex-direction: column;\n        width: 70px !important;\n        height: 50px !important;\n     }\n\n    #SolutionsSectionThree-card1-head,\n    #SolutionsSectionThree-card2-head,\n    #SolutionsSectionThree-card3-head{\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    }\n    #SolutionsSectionThree-card1-para {\n        width: 90%;\n        height: 162px;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 25px;\n        color: #1C2640;\n        padding: 10px 30px;\n    }\n    #SolutionsSectionThree-card2-para {\n        width: 90%;\n        height: 153px;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 25px;\n        color: #1C2640;\n        margin-top: 7%;\n        padding: 10px 30px;\n    }\n    #SolutionsSectionThree-card3-para {\n        width: 90%;\n        height: 153px;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 25px;\n        color: #1C2640;\n        margin-top: 7%;\n        padding: 10px 30px;\n    }\n    #SolutionsSectionThree-discoverAll {\n        color: #EC6927;\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 20px;\n        width: 90%;\n        margin-top: 5%;\n        cursor: pointer;\n    }\n\n    div#SolutionsSectionThree-left-middle-bottom {\n        padding: 30px;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        margin-top: -10px;\n        color: #fff;\n        font-weight: 600;\n        font-size: 16px;\n        padding-bottom: 45px;\n    }\n\n    #SolutionsSectionThree-explore-platform-btn{\n        background: #EC6927;\n        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n        border-radius: 3px;\n        border: none;\n        color: white;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 13.5px;\n        cursor: pointer;\n        padding: 10px 20px;\n    }\n\n    #SolutionsSectionThree-bottom{\n        flex-direction: row;\n        justify-content: flex-start;\n        background: #fff;\n        width: 100%;\n        padding: 75px 130px;\n        scroll-snap-align: end;\n       \n    }\n\n    .SolutionsSectionThree-footer-head {\n        font-size: 35px;\n        color: #1c2640;\n\n    }\n\n\n    .SolutionsSectionThree-footer-content {\n        margin-top: 3%;\n        display: flex;\n    }\n\n    .SolutionsSectionThree-btn-footer {\n        margin-left: 20%;\n    }\n\n    .SolutionsSectionThree-footer-disc {\n        width: 34%;\n    }\n\n    button#SolutionsSectionThree-schedule-btn {\n        background: #ec6927;\n        border-radius: 50px;\n        padding: 10px 20px;\n        margin-right: 20px;\n        color: #fff;\n        border: 1px solid #ec6927;\n    }\n    \n    button#SolutionsSectionThree-watch-btn {\n        background: #1c2640;\n        border-radius: 50px;\n        padding: 10px 20px;\n        margin-right: 20px;\n        color: #fff;\n        border: 1px solid #1c2640;\n    }\n\n    img#SolutionsSectionThree-dots-bg {\n        margin-top: -3%;\n        float: right;\n        width: 200px;\n        margin-right: -140px;\n        margin-bottom: -200px;\n        height: 90px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
